<template>
    <!-- ALERT NOT SEND OFFER  - VISIBLE ONLY FOR ADIVSOR  -->
    <div
        v-if="hasNotSentOffers && createOfferRoute"
        class="bg-blue-100 my-4 p-3 flex rounded"
    >
        <div><ExclamationIcon class="mr-2 h-5 w-5 text-blue-800" /></div>
        <div>
            <h3 class="text-sm font-bold text-blue-800">
                {{ $t("offers.offerNotSent") }}
            </h3>
            <div class="mt-2 text-sm text-blue-700">
                <p>
                    {{ $t("offers.offerNotSentDesc") }}
                </p>
            </div>
        </div>
    </div>

    <!-- ALERT NOT APPROVED -->
    <div v-if="hasNotApprovedOffers" class="bg-yellow-100 my-4 p-3 flex rounded">
        <div><ExclamationIcon class="mr-2 h-5 w-5 text-yellow-800" /></div>
        <div>
            <h3 class="text-sm font-bold text-yellow-800">
                {{ $t("offers.offerNotApproved") }}
            </h3>
            <div class="mt-2 text-sm text-yellow-700">
                <p>
                    {{ $t("offers.offerNotApprovedDesc") }}
                </p>
            </div>
        </div>
    </div>

    <!-- Offers Section -->
    <div class="p-2 md:p-6">
        <h2 class="font-bold uppercase tracking-wider">{{ $t("topics.offers") }}</h2>
        <table class="w-full divide-y divide-gray-200 mt-2 md:mt-4">
            <thead class="bg-minplan-lightgreybeige">
                <tr>
                    <th
                        scope="col"
                        class="px-1 lg:px-3 py-2 lg:py-3 text-left text-xs font-medium text-minplan-beige uppercase tracking-wider"
                    >
                        {{ $t("topics.offer") }}
                    </th>
                    <th
                        scope="col"
                        class="hidden lg:table-cell px-1 lg:px-3 py-2 lg:py-3 text-left text-xs font-medium text-minplan-beige uppercase tracking-wider"
                    >
                        {{ $t("topics.date") }}
                    </th>
                    <th
                        scope="col"
                        class="hidden lg:table-cell px-1 lg:px-3 py-2 lg:py-3 text-left text-xs font-medium text-minplan-beige uppercase tracking-wider"
                    >
                        {{ $t("topics.bkp") }}
                    </th>
                    <th
                        scope="col"
                        class="hidden md:table-cell px-1 lg:px-3 py-2 lg:py-3 text-center text-xs font-medium text-minplan-beige uppercase tracking-wider"
                    >
                        {{ $t("topics.version") }}
                    </th>
                    <th
                        scope="col"
                        class="hidden lg:table-cell px-1 lg:px-3 py-2 lg:py-3 text-right text-xs font-medium text-minplan-beige uppercase tracking-wider"
                    >
                        {{ $t("topics.budget") }}
                    </th>
                    <th
                        scope="col"
                        class="hidden lg:table-cell px-1 lg:px-3 py-2 lg:py-3 text-right text-xs font-medium text-minplan-beige uppercase tracking-wider"
                    >
                        {{ $t("topics.offered") }}
                    </th>
                    <th
                        scope="col"
                        class="px-1 lg:px-3 py-2 lg:py-3 text-right text-xs font-medium text-minplan-beige uppercase tracking-wider"
                    >
                        {{ $t("topics.difference") }}
                    </th>
                    <th
                        scope="col"
                        class="px-1 lg:px-3 py-2 lg:py-3 text-center text-xs font-medium text-minplan-beige uppercase tracking-wider"
                    >
                        {{ $t("topics.state") }}
                    </th>
                    <th></th>
                </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
                <tr v-if="offers.length === 0">
                    <td
                        colspan="7"
                        class="p-3 whitespace-nowrap text-sm font-medium text-gray-900"
                    >
                        {{ $t("topics.emptyOffers") }}
                    </td>
                </tr>
                <tr v-for="offer in offers" :key="offer.uuid">
                    <td
                        class="text-xs px-1 lg:px-3 py-2 lg:py-3 whitespace-nowrap text-sm font-medium text-gray-900"
                    >
                        {{ offer.title }} {{ offer.number }}
                        <button
                            type="button"
                            v-if="offer.comment"
                            @click="showComments(offer)"
                            class="inline-block bg-minplan-beige rounded-full px-2 py-1"
                        >
                            <ChatAltIcon
                                class="h-5 w-5 text-minplan-darkbeige inline-block"
                            />
                        </button>
                    </td>
                    <td
                        class="text-xs hidden lg:table-cell px-1 lg:px-3 py-2 lg:py-3 whitespace-nowrap text-sm font-medium text-gray-900"
                    >
                        {{ offer.createdAt }}
                    </td>
                    <td
                        class="text-xs hidden lg:table-cell px-1 lg:px-3 py-2 lg:py-3 whitespace-nowrap text-sm font-medium text-gray-900"
                    >
                        <span v-if="offer.customBkp">{{ offer.customBkp }}</span>
                        <span v-else>{{ offer.bkp }}</span>
                    </td>
                    <td
                        class="text-xs hidden md:table-cell px-1 lg:px-3 py-2 lg:py-3 whitespace-nowrap text-center text-sm font-medium text-gray-900"
                    >
                        <button v-if="historyOfferRoute" type="button">
                            {{ offer.version }}
                            <InformationCircleIcon
                                @click="openHistoryModal(offer)"
                                class="-mt-1 ml-1 h-5 w-5 inline text-minplan-darkbeige hover:text-minplan-darkgreybeige"
                            />
                        </button>
                    </td>
                    <td
                        class="text-xs hidden lg:table-cell px-1 lg:px-3 py-2 lg:py-3 whitespace-nowrap text-sm text-gray-900 text-right"
                    >
                        {{ offer.budget }}
                    </td>
                    <td
                        class="text-xs hidden lg:table-cell px-1 lg:px-3 py-2 lg:py-3 whitespace-nowrap text-sm text-gray-900 text-right"
                    >
                        {{ offer.cost }}
                    </td>
                    <td
                        class="text-xs px-1 lg:px-3 py-2 lg:py-3 whitespace-nowrap text-sm text-gray-900 text-right"
                    >
                        {{ offer.diff }}
                    </td>
                    <td
                        class="text-xs px-1 lg:px-3 py-2 lg:py-3 whitespace-nowrap text-sm text-gray-900 text-center"
                    >
                        <span
                            :class="offer.style"
                            class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full"
                        >
                            {{ $t("offers.state." + offer.state) }}
                        </span>
                    </td>
                    <td class="text-right">
                        <button v-if="offer.filename && isViewable(offer.filename)" type="button" @click="viewFile(offer.viewLink, offer.filename)" title="View" class="ml-3">
                            <EyeIcon class="h-5 w-5 text-minplan-darkbeige hover:text-minplan-darkgreybeige" />
                        </button>
                        <button
                            v-if="offer.showRelease"
                            @click="release(offer)"
                            type="button"
                            class="px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded bg-blue-100 text-blue-800"
                        >
                            <PaperAirplaneIcon
                                class="h-5 w-5 text-blue-500 hover:text-minplan-darkgreybeige"
                            />
                        </button>
                        <button
                            type="button"
                            v-if="offer.showApprove"
                            @click="approve(offer)"
                            class="px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded bg-lime-100 text-lime-800"
                        >
                            <CheckIcon
                                class="h-5 w-5 text-lime-500 hover:text-minplan-darkgreybeige"
                            />
                        </button>
                        <button
                            type="button"
                            v-if="offer.showDecline && rejectOfferRoute"
                            @click="openRejectModal(offer)"
                            class="ml-3 px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded bg-red-100 text-red-800"
                        >
                            <XIcon
                                class="h-5 w-5 text-red-500 hover:text-minplan-darkgreybeige"
                            />
                        </button>
                        <button
                            type="button"
                            v-if="offer.showEdit && editOfferRoute"
                            @click="openEditModal(offer)"
                        >
                            <PencilIcon
                                class="ml-3 h-5 w-5 text-minplan-darkbeige hover:text-minplan-darkgreybeige"
                            />
                        </button>
                        <button
                            type="button"
                            v-if="offer.showReplace && replaceOfferRoute"
                            @click="openReplaceModal(offer)"
                        >
                            <RefreshIcon
                                class="ml-3 h-5 w-5 text-minplan-darkbeige hover:text-minplan-darkgreybeige"
                            />
                        </button>
                        <button type="button" @click="download(offer)" v-if="offer.filename">
                            <CloudDownloadIcon
                                class="ml-3 h-5 w-5 text-minplan-darkbeige hover:text-minplan-darkgreybeige"
                            />
                        </button>
                        <button
                            type="button"
                            v-if="deleteOfferRoute"
                            @click="openDeleteModal(offer)"
                        >
                            <TrashIcon
                                class="ml-3 h-5 w-5 text-minplan-darkbeige hover:text-minplan-darkgreybeige"
                            />
                        </button>
                    </td>
                </tr>
            </tbody>
            <tfoot>
                <td colspan="9" class="text-right text-sm text-gray-500">
                    {{ $t("topics.inclVat") }}
                </td>
            </tfoot>
        </table>

        <!-- Upload Offer Button -->
        <div class="flex justify-end mt-3">
            <button
                type="button"
                v-if="createOfferRoute"
                @click="openCreateModal"
                class="ml-3 inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium text-white bg-minplan-greybeige hover:bg-minplan-lightgreybeige focus:outline-none uppercase"
            >
                <CloudUploadIcon class="-ml-1 mr-2 h-5 w-5 text-minplan-darkgreybeige" />
                <span class="inline font-bold">{{ $t("offers.new") }}</span>
            </button>
        </div>
    </div>

    <!-- Comments Modal -->
    <jet-dialog-modal :show="showModal" @close="closeModal">
        <template #title>
            {{ $t("offers.showComment") }}
        </template>

        <template #content>
            {{ currentComment }}
        </template>

        <template #footer>
            <button
                @click="closeModal"
                type="button"
                class="inline-block uppercase font-semibold text-xs tracking-widest"
            >
                {{ $t("actions.close") }}
            </button>
        </template>
    </jet-dialog-modal>

    <file-preview-modal
        :show="previewFile !== null"
        :file-url="previewFile?.url"
        :file-name="previewFile?.name"
        @close="previewFile = null"
    />

</template>

<script>
import {
    ChatAltIcon,
    CheckIcon,
    CloudDownloadIcon,
    CloudUploadIcon,
    InformationCircleIcon,
    PaperAirplaneIcon,
    ExclamationIcon,
    PencilIcon,
    RefreshIcon,
    TrashIcon,
    XIcon,
    EyeIcon,
} from "@heroicons/vue/outline";
import { downloadFile } from "@/Shared/Utils/downloader";
import JetDialogModal from "@/Jetstream/DialogModal";
import FilePreviewModal from "@/Shared/Components/FilePreviewModal.vue";

export default {
    props: [
        "topic",
        "offers",
        "createOfferRoute",
        "deleteOfferRoute",
        "updateOfferRoute",
        "replaceOfferRoute",
        "rejectOfferRoute",
        "historyOfferRoute",
        "editOfferRoute",
    ],
    data() {
        return {
            showModal: false,
            currentComment: null,
            previewFile: null,
        };
    },
    components: {
        CloudUploadIcon,
        CloudDownloadIcon,
        PencilIcon,
        TrashIcon,
        PaperAirplaneIcon,
        RefreshIcon,
        InformationCircleIcon,
        ExclamationIcon,
        CheckIcon,
        XIcon,
        ChatAltIcon,
        JetDialogModal,
        FilePreviewModal,
        EyeIcon,
    },
    methods: {
        isViewable(fileName) {
            if (!fileName) return false;
            const ext = fileName.toLowerCase().split('.').pop();
            return ['pdf', 'jpg', 'jpeg', 'png', 'gif', 'svg', 'webp'].includes(ext);
        },
        viewFile(url, name) {
            const ext = name.toLowerCase().split('.').pop();
            if (['jpg', 'jpeg', 'png', 'gif', 'svg', 'webp'].includes(ext)) {
                window.Fancybox.show([{ src: url, type: "image" }]);
            } else {
                this.previewFile = { url, name };
            }
        },
        openCreateModal() {
            this.$inertia.visitInModal(
                this.route(this.createOfferRoute, this.topic.uuid)
            );
        },
        openDeleteModal(offer) {
            this.$inertia.visitInModal(
                this.route(this.deleteOfferRoute, {
                    topic: this.topic.uuid,
                    offer: offer.uuid,
                })
            );
        },
        openRejectModal(offer) {
            this.$inertia.visitInModal(
                this.route(this.rejectOfferRoute, {
                    topic: this.topic.uuid,
                    offer: offer.uuid,
                })
            );
        },
        openHistoryModal(offer) {
            this.$inertia.visitInModal(
                this.route(this.historyOfferRoute, {
                    topic: this.topic.uuid,
                    offer: offer.uuid,
                })
            );
        },
        openEditModal(offer) {
            this.$inertia.visitInModal(
                this.route(this.editOfferRoute, {
                    topic: this.topic.uuid,
                    offer: offer.uuid,
                })
            );
        },
        openReplaceModal(offer) {
            this.$inertia.visitInModal(
                this.route(this.replaceOfferRoute, {
                    topic: this.topic.uuid,
                    offer: offer.uuid,
                })
            );
        },
        closeModal() {
            this.showModal = false;
            this.currentComment = null;
        },
        showComments(offer) {
            this.showModal = true;
            this.currentComment = offer.comment;
        },
        release(offer) {
            this.update(
                {
                    updateState: {
                        transition: "release",
                    },
                },
                offer
            );
        },
        approve(offer) {
            this.update(
                {
                    updateState: {
                        transition: "approve",
                    },
                },
                offer
            );
        },
        download(offer) {
            downloadFile(offer.downloadLink, offer.filename);
        },
        update(payload, offer) {
            this.$inertia.post(
                this.route(this.updateOfferRoute, {
                    topic: this.topic.uuid,
                    offer: offer.uuid,
                }),
                payload,
                {
                    onSuccess: () =>
                        this.$notify({
                            group: "success",
                            title: "actions.success",
                            text: "offers.updated",
                        }),
                }
            );
        },
    },
    computed: {
        hasNotSentOffers() {
            let filtered = this.offers.filter((offer) => offer.state === "created");
            return filtered.length > 0;
        },
        hasNotApprovedOffers() {
            let filtered = this.offers.filter(
                (offer) => offer.state === "readyForApproval"
            );
            return filtered.length > 0;
        },
    },
};
</script>

<style scoped></style>
